const $ = require('jquery');
const SecondaryDemoFormStepper = require('../form/SecondaryDemoFormStepper');

module.exports = class GateStart {
  constructor(id) {
    new SecondaryDemoFormStepper(
      $(`#${id} [data-component="secondary-demo-form-stepper"]`)[0].id
    );

    window.document.addEventListener('itbl.marketo_submit', e => {
      if (e.detail.formId === '1134') {
        $(`#${id} [data-component="gate-overlay"]`).css('display', 'none');
        $(`#${id} [data-component="gate-content-wrap"]`).css('filter', 'unset');
      }
    }, false);
  }
}